module.exports = "/_next/static/images/138515b34851693382b3b2f9a8270876-notaxes@3x.jpg";